import {
  CHANGE_LOG_TITLE,
  CHANGE_LOG_VIEW_ALL_CHANGES
} from '@bo-constants/member/memberCopy';
import {
  MemberDrawer,
  MemberDrawerHeader
} from '@bo-components/members/drawer';
import { useCallback, useEffect, useState } from 'react';
import { MemberChangeLogTable } from '@bo-components/members/memberChangeLogs';
import { useMemberChangeLogs } from '@bo-hooks/members';

export interface MemberChangeLogDrawerProps {
  memberId: string;
  onClose: () => void;
}

export const MemberChangeLogDrawer = ({
  memberId,
  onClose
}: MemberChangeLogDrawerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { changeLogs, isError, isFetching } = useMemberChangeLogs({
    memberId
  });

  useEffect(() => {
    setIsOpen(true);
  }, []);

  const handleCloseDrawer = useCallback(() => {
    setIsOpen(false);
    setTimeout(() => onClose(), 200); // Delay to allow transition animation to complete
  }, [onClose]);

  return (
    <MemberDrawer
      isOpen={isOpen}
      onCloseDrawer={handleCloseDrawer}
      size="xlarge"
    >
      {/* Header */}
      <MemberDrawerHeader onClose={onClose}>
        <p className="text-soClean-100 leading-none">{CHANGE_LOG_TITLE}</p>
      </MemberDrawerHeader>

      {/* Content */}
      <div className="p-6">
        <p className="text-soClean-180 pb-4 text-xs">
          {CHANGE_LOG_VIEW_ALL_CHANGES}
        </p>
        <MemberChangeLogTable
          changeLogs={changeLogs}
          isError={isError}
          isFetching={isFetching}
        />
      </div>
    </MemberDrawer>
  );
};
